import { T } from '@tribeplatform/react-components/i18n'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { EmptyState as EmptyStateComponent } from '@tribeplatform/react-ui-kit/EmptyState'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export const EmptyState = () => {
  return (
    <Card>
      <Card.Content>
        <div className="my-16">
          <EmptyStateComponent
            title={
              <T defaultMessage="Nothing here!" id="Generics.NothingHere" />
            }
            icon={<SvgIcon name="post" />}
          />
        </div>
      </Card.Content>
    </Card>
  )
}
